// Scheduled (future-dated) feed posts: detection + the badge label.

export function isScheduledArticle(article, now = new Date()) {
    if (!article || !article.publishDate) {
        return false;
    }
    const time = new Date(article.publishDate).getTime();
    if (Number.isNaN(time)) {
        return false;
    }
    return time > now.getTime();
}

// "fre. 16. okt. 08:00" in Norwegian time, regardless of the viewer's zone.
export function scheduledLabel(publishDate) {
    const date = new Date(publishDate);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    const parts = new Intl.DateTimeFormat('nb-NO', {
        timeZone: 'Europe/Oslo',
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(date);
    const get = type => (parts.find(p => p.type === type) || {}).value || '';
    return `${get('weekday')} ${get('day')}. ${get('month')} ${get('hour')}:${get('minute')}`;
}
